import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { BehaviorSubject } from 'rxjs';

// Ported from the PO project's theme.service.ts (same mechanism: a class on
// <body> selects which --md-sys-color-* token set applies, persisted to
// localStorage). Theme names/colors are reev-admin's own — 'theme-azure'
// (the existing blue brand) is the default instead of PO's rose-quartz so
// first load looks unchanged from before this feature existed.
export type Theme = 'theme-azure' | 'theme-teal' | 'theme-violet' | 'theme-amber' | 'theme-midnight';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private readonly THEME_KEY = 'reev-admin-theme';
  private currentThemeSubject = new BehaviorSubject<Theme>('theme-azure');

  public currentTheme$ = this.currentThemeSubject.asObservable();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    this.initTheme();
  }

  private initTheme() {
    if (isPlatformBrowser(this.platformId)) {
      const storedTheme = localStorage.getItem(this.THEME_KEY) as Theme;
      if (storedTheme) {
        this.setTheme(storedTheme);
      } else {
        this.setTheme('theme-azure');
      }
    }
  }

  public setTheme(theme: Theme) {
    if (isPlatformBrowser(this.platformId)) {
      const themes: Theme[] = ['theme-azure', 'theme-teal', 'theme-violet', 'theme-amber', 'theme-midnight'];
      themes.forEach(t => document.body.classList.remove(t));

      document.body.classList.add(theme);
      localStorage.setItem(this.THEME_KEY, theme);
      this.currentThemeSubject.next(theme);
    }
  }
}
